import { Component, input, output } from '@angular/core';
import { Modal } from 'flowbite';
import { AnimationOptions } from 'ngx-lottie';
import { InputType, UserRole } from 'src/app/models/enums';
import { LiteralService, UtilsService } from 'src/app/services';
import { images } from 'src/images';

@Component({
  selector: 'app-modal-edit-schedule',
  templateUrl: './modal-edit-schedule.component.html',
  styleUrl: './modal-edit-schedule.component.scss',
  standalone: false
})
export class ModalEditScheduleComponent {

  readonly id = input<string>();
  readonly modal = input<Modal>();
  readonly edit = input<boolean>(false);
  readonly loading = input<boolean>(false);
  readonly clientId = input<number | undefined>();
  readonly userRole = input<UserRole>();
  readonly backingIdPlaceholder = input<string>('');
  readonly action = output<any>();

  public images = images;
  public UserRole = UserRole;
  public InputType = InputType;

  public timeObject = {
    height: 48,
    fontSize: 16,
    value: '',
    edit: {
      inputType: InputType.TIME
    }
  };

  public editData: {
    driver: any;
    vehicle: any;
    startTime: string;
    endTime: string;
    gtfsId: string;
    extKey: string;
    backingId: string;
    comment: string;
  } = {
    driver: null,
    vehicle: null,
    startTime: '',
    endTime: '',
    gtfsId: '',
    extKey: '',
    backingId: '',
    comment: ''
  };

  public loadingAnimation: AnimationOptions = {
    path: '/assets/animations/loading.json'
  };

  constructor(public literalService: LiteralService, public utilsService: UtilsService) {}

  getTimeObject(type: 'startTime' | 'endTime') {
    const timeObject = {...this.timeObject};
    timeObject.value = this.editData[type];
    return timeObject;
  }

  updateSelection(selected: { value: any; label: string }, type: 'driver' | 'vehicle') {
    this.editData[type] = { id: selected.value, value: selected.value, label: selected.label };
  }

  updateData(data: any, type: 'driver' | 'vehicle' | 'startTime' | 'endTime' | 'gtfsId' | 'extKey' | 'backingId' | 'comment') {
    if (data.options) {
      this.editData[type] = data.options[0];
    } else {
      this.editData[type] = data.target.value;
    }
  }

  getTextObject(type: 'gtfsId' | 'extKey' | 'backingId', inputType: InputType = InputType.TEXT) {
    return {
      height: 48,
      fontSize: 16,
      value: this.editData[type],
      edit: {
        inputType,
        placeholder: type === 'backingId' ? this.backingIdPlaceholder() : ''
      }
    };
  }

  onSubmit() {
    const payload = {
      ...this.editData,
      gtfsId: this.editData.gtfsId?.trim(),
      extKey: this.editData.extKey?.trim(),
      backingId: this.editData.backingId?.trim()
    };
    this.action.emit(payload);
    this.modal()?.hide();
    this.resetForm();
  }

  resetForm() {
    this.editData = {
      driver: null,
      vehicle: null,
      startTime: '',
      endTime: '',
      gtfsId: '',
      extKey: '',
      backingId: '',
      comment: ''
    };
  }
}
